import { BasketClientMetadata, CxsBasket } from '../model';

// Used for tracking what products have an update in progress. Exists only in FE, array is removed on BE response
export const markProductUpdate = (
    basket: CxsBasket,
    variantNo: string
): Pick<BasketClientMetadata, 'updatesInProgress'> | undefined => {
    if (!basket.updatesInProgress) {
        return { updatesInProgress: [{ variantNo }] };
    } else if (!basket.updatesInProgress.some(({ variantNo: existingVariantNo }) => existingVariantNo === variantNo)) {
        return { updatesInProgress: basket.updatesInProgress.concat({ variantNo }) };
    } else {
        return undefined;
    }
};
